import { render } from "./ControlsRightComponent.vue?vue&type=template&id=aadd9bd6"
import script from "./ControlsRightComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsRightComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script